import { injectIntl } from 'react-intl';

import InfoList from './InfoList';

export default injectIntl(InfoList);
